import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export interface ProblematicCampaignsHeaderProps {
  clientLogin?: string;
  count: number;
}

export const ProblematicCampaignsHeader = ({
  clientLogin,
  count,
}: ProblematicCampaignsHeaderProps) => {
  const backUrl = clientLogin ? `/${clientLogin}` : "/";

  return (
    <div className="flex flex-col gap-3">
      {/* Кнопка «Назад ко всем кампаниям» */}
      <div>
        <Link
          to={backUrl}
          className="inline-flex items-center gap-1.5 text-xs font-medium text-neutral-400 hover:text-neutral-200 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Все кампании</span>
        </Link>
      </div>

      {/* Заголовок без обёртки в карточку */}
      <div className="flex flex-row items-center gap-4">
        <div className="min-w-0">
          <h1 className="text-lg font-semibold truncate leading-snug">
            Кампании с проблемами
          </h1>
          <p className="text-xs text-neutral-400">
            {clientLogin ? `Клиент: ${clientLogin} • ` : ""}
            {count > 0
              ? `Выявлено проблемных кампаний: ${count}`
              : "Проблем не обнаружено"}
          </p>
        </div>
      </div>
    </div>
  );
};
